import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fees-structure',
  templateUrl: './fees-structure.component.html',
  styleUrls: ['./fees-structure.component.scss']
})
export class FeesStructureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
